import { LocalAsyncStorage } from '@evertel/utils'
import { decorate, injectable } from 'inversify'

export class LocalAsyncStorageWebImplementation implements LocalAsyncStorage {
    async getItem(key: string): Promise<string | null> {
        return localStorage.getItem(key)
    }

    async setItem(key: string, value: string): Promise<void> {
        localStorage.setItem(key, value)
    }

    async removeItem(key: string): Promise<void> {
        localStorage.removeItem(key)
    }

    async clear(): Promise<void> {
        localStorage.clear()
    }

    async getObject<T,>(key: string, defaultValue: T): Promise<T> {
        const item = localStorage.getItem(key)
        if (item !== null) {
            return JSON.parse(item) as T
        }
        return defaultValue
    }

    async setObject<T,>(key: string, obj: T): Promise<void> {
        localStorage.setItem(key, JSON.stringify(obj))
    }

    async length(): Promise<number> {
        return localStorage.length
    }

    async list(): Promise<void> {
        console.log('LocalStorage contents:')
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)
            if (key !== null) {
                console.log(`${key}: ${localStorage.getItem(key)}`)
            }
        }
    }
}

decorate(injectable(), LocalAsyncStorageWebImplementation)
